
module.exports = Object.freeze({
    url: process.env.REACT_APP_API_URL || "https://tolet-roomonrent-server.onrender.com",
});
